import React from "react";
import styles from "./Button.module.scss";
import { useTranslation } from "react-i18next";

interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  full?: boolean;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  type = "button",
  disabled = false,
  className = "",
  full = false,
  loading = false,
}) => {
  const buttonStyle = full ? { width: "100%" } : {};
  const { t } = useTranslation("translation");
  return (
    <button
      style={buttonStyle}
      type={type}
      className={`${styles.main_button} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {loading ? t("loading") : children}
    </button>
  );
};

export default Button;
